import * as React from "react";
import type { SVGProps } from "react";
export const SvgMiscReturnArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 12 12" {...props}>
    <path
      fill="currentColor"
      d="m2.914 3.5 1.268 1.268-.707.707L1 3 3.475.525l.707.707L2.914 2.5H6.5a4 4 0 1 1 0 8H2v-1h4.5a3 3 0 0 0 0-6H2.914Z"
    />
  </svg>
);
